import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, switchMap, tap } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { AppService } from "src/app/app.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class ProfileSelectionService {
  userProfileApiUrl:string;
  prdCtx: string;
  allCompanyAccess: any;

  constructor(private http: HttpClient, private cookieService: CookieService,private appService: AppService ) {
    this.appService.getConfigStatus().subscribe(_configStatus => {
      if (_configStatus) {
        const _appConfig = this.appService.getGlobalConfig();
        this.prdCtx= environment.ProductIdAlias;
         this.userProfileApiUrl = _appConfig.userProfileApiUrl;
      }
    });
   }

   hasCompanyAccess(): Observable<any> {
    if(!localStorage.getItem("userid") || !localStorage.getItem("cstid")){
      return this.getAllCompanyAccess(this.userProfileApiUrl, this.cookieService.get('access_token'), this.prdCtx)
      .pipe(
        switchMap(allCompanyAccess => {
          if (!allCompanyAccess || allCompanyAccess.length === 0) {
            return of(false); // Return false when user doesn't have any company access
          }
          this.allCompanyAccess = allCompanyAccess
          return of(void 0);
        }),
          catchError(error => {
        return of(void 0); 
        })
      );
    }else{
      return of(void 0); 
    }
  }
   
   includeIdealUX(): Observable<void> {
    const queryParams = new URLSearchParams(window.location.search);
  
    // Check if the "redirectedFromMenu" parameter is set to "true"
    if (queryParams.get('redirectedFromMenu') === 'true' && queryParams.get('switchcompany')) {
      return this.getContexualProfile(this.userProfileApiUrl, this.cookieService.get('access_token'), this.prdCtx)
        .pipe(
          switchMap(contextualProfile => {
            if(contextualProfile.cstid){
              this.appService.setUserIdAndType(contextualProfile?.cstid)
              localStorage.setItem("cstid", contextualProfile?.cstid);
              localStorage.setItem("userid", contextualProfile?.userid);
              localStorage.setItem("customername",contextualProfile?.customerName );
              localStorage.setItem("pcc_highest_parent_cstid",contextualProfile?.highestParent);
              localStorage.setItem("pcc_ird",contextualProfile?.ird);
              localStorage.setItem(`profile_selected_${this.cookieService.get('prd_ctx')}`,contextualProfile?.profileSelected);
              window.dispatchEvent(new Event('customernameChange'));
            }
            return of(void 0);  // Return an observable that completes
          }),
          catchError(error => {
            return of(void 0);  // Return an observable that completes even on error
          })
        );
    } else if(!localStorage.getItem("cstid")){
      // Checking If context exists for Initial request 
      return this.getContexualProfile(this.userProfileApiUrl, this.cookieService.get('access_token'), this.prdCtx)
        .pipe(
          switchMap(contextualProfile => {
            let isEligibile = this.allCompanyAccess && this.allCompanyAccess.filter(cst => cst.cstid == contextualProfile.cstid).length == 1
            if(isEligibile){
              localStorage.setItem("cstid", contextualProfile?.cstid);
              localStorage.setItem("userid", contextualProfile?.userid);
              localStorage.setItem("customername",contextualProfile?.customerName );
              localStorage.setItem("pcc_highest_parent_cstid",contextualProfile?.highestParent);
              localStorage.setItem("pcc_ird",contextualProfile?.ird);
              window.dispatchEvent(new Event('customernameChange'));
            }
            return of(void 0);  // Return an observable that completes
          }),
          catchError(error => {
            return of(void 0);  // Return an observable that completes even on error
          })
        );
    }else {
      return of(void 0);  // Return an observable that completes immediately if conditions are not met
    }
  }

  getContexualProfile(path:string, accessToken: string, prdCtx: string): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", `Bearer ${accessToken}`);
    const url = `${path}/context/${prdCtx}/v2`;
    return this.http.get(url, { headers: headers }).pipe(tap());
  }

  getAllCompanyAccess(path:string, accessToken: string, prdCtx: string): Observable<any> {
    const headers = new HttpHeaders().set("Authorization", `Bearer ${accessToken}`);
    const url = `${path}/customer/detail/user/product/${prdCtx}/v2`;
    return this.http.get(url, { headers: headers }).pipe(tap());
  }

  setProductContextCookie(){
    if (!this.cookieService.get("prd_ctx")) {
      this.cookieService.set('prd_ctx', this.prdCtx, null, '/', '', true,"Strict");
    }
  }
}
